import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Form, Input, Switch, Button, Space, message } from 'antd';
import { useAuth } from '../../../contexts/AuthContext';

const { Title, Paragraph } = Typography;

const GoogleAds = () => {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();
  const { token } = useAuth();

  const onSubmit = async () => {
    try {
      await form.validateFields();
      setSaving(true);
      const v = form.getFieldsValue();
      const payload = {
        developer_token: v.developerToken,
        client_id: v.clientId,
        client_secret: v.clientSecret,
        refresh_token: v.refreshToken,
        login_customer_id: v.loginCustomerId,
        use_test_account: v.useTestAccount,
      };
      const res = await fetch('/api/integrations/google-ads', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        let err = 'Failed to save Google Ads settings';
        try { const j = await res.json(); if (j?.error) err = j.error; } catch {}
        throw new Error(err);
      }
      message.success('Google Ads settings saved');
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    const load = async () => {
      try {
        if (!token) return;
        const res = await fetch('/api/integrations/google-ads', {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const d = await res.json();
        if (!d) return;
        form.setFieldsValue({
          developerToken: d.developer_token || '',
          clientId: d.client_id || '',
          clientSecret: d.client_secret || '',
          refreshToken: d.refresh_token || '',
          loginCustomerId: d.login_customer_id || '',
          useTestAccount: !!d.use_test_account,
        });
      } catch (e) {
        // ignore
      }
    };
    load();
  }, [token, form]);

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Client' }, { title: 'Integrations' }, { title: 'Google Ads' }]} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Google Ads</Title>
        <Space><Button type="primary" onClick={onSubmit} loading={saving}>Save</Button></Space>
      </div>
      <Card>
        <Paragraph type="secondary">Connect your Google Ads account and set defaults.</Paragraph>
        <Form layout="vertical" form={form} initialValues={{ useTestAccount: false }}>
          <Form.Item label="Developer Token" name="developerToken" rules={[{ required: true }]}> 
            <Input placeholder="Developer Token" />
          </Form.Item>
          <Form.Item label="OAuth Client ID" name="clientId" rules={[{ required: true }]}> 
            <Input placeholder="OAuth Client ID" />
          </Form.Item>
          <Form.Item label="OAuth Client Secret" name="clientSecret" rules={[{ required: true }]}> 
            <Input.Password placeholder="OAuth Client Secret" />
          </Form.Item>
          <Form.Item label="Refresh Token" name="refreshToken" rules={[{ required: true }]}> 
            <Input.Password placeholder="OAuth Refresh Token" />
          </Form.Item>
          <Form.Item label="Login Customer ID (optional)" name="loginCustomerId"> 
            <Input placeholder="e.g., 123-456-7890" />
          </Form.Item>
          <Form.Item label="Use Test Account" name="useTestAccount" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default GoogleAds;
